import { gql } from '@apollo/client'

export const GET_USER_COUNTRY = gql`
query getUserCountry ($company_id: ID!) {
    getUserCountry (company_id: $company_id)
}
`
